import { render, staticRenderFns } from "./SdsTableSection1Manufacturer.vue?vue&type=template&id=38188a0d"
import script from "./SdsTableSection1Manufacturer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection1Manufacturer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports